import { useTranslation } from "react-i18next";
import { Widget } from "datastake-daf/dist/components";
import { useEffect, useRef, useState } from "react";
import { defaultMapConfig, useMapConfig } from "../../../../../components/SubjectsMap/helper";
import styled from "styled-components";
import { PopUp } from "../../../components/Map/hook";
import { createRoot } from "react-dom/client";

const Style = styled.div`
  overflow: hidden;
  border-radius: 0px 0px 4px 4px;

  .map-cont {
    width: 100%;
    height: 280px;

    .map-marker {
      background: #3D8EDB;
      border: 2px solid white;
      border-radius: 100% 100% 100% 0px;
    }

    .leaflet-popup-content-wrapper {
      .leaflet-popup-content {
        margin: 0px !important;
        width: unset !important;
        padding: 6px 24px 6px 14px;
        
        .popup-header {
          display: flex;
  
          h2 {
            white-space: nowrap;
            margin-bottom: 0px;
            font-size: 14px;
          }
        }
      } 
    }
  }
`;

export default function Map({ data = {}, loading }) {
  const roots = useRef([]);
  const container = useRef();
  const { t } = useTranslation();
  const [marker, setMarker] = useState();
  const [mapRef, setMapRef] = useState();
  const { TILE_LAYER_URL, MAP_TOKEN } = useMapConfig();

  const createInstance = () => {
    if (container.current) {
      // eslint-disable-next-line no-undef
      const map = L.map(container.current, {
        ...defaultMapConfig,
        preferCanvas: false,
        center: [-0.02, 37],
      });
      map.fitBounds([[20, 20], [-20, -20]], { padding: [40, 40] });

      // eslint-disable-next-line no-undef
      L.control.scale().addTo(map);
      // eslint-disable-next-line no-undef
      L.tileLayer(TILE_LAYER_URL, {
        access_token: MAP_TOKEN,
        unloadInvisibleTiles: true,
        updateWhenIdle: true,
        reuseTiles: true
      }).addTo(map);

      return map;
    }
  };

  useEffect(() => {
    if (!mapRef) {
      setMapRef(createInstance());
    }
  }, []);

  const getMarkerContent = (data = {}) => {
    const div = document.createElement('div');
    const root = createRoot(div);
    root.render(<PopUp data={data} />);
    roots.current.push(root);
    return div;
  };

  useEffect(() => () => {
    if (mapRef) {
      roots.current.forEach((root) => {
        setTimeout(() => {
          root.unmount();
        });
      })

      roots.current = [];

      mapRef.off();
      mapRef.remove();
    }
  }, [mapRef]);

  useEffect(() => {
    if (mapRef) {
      roots.current.forEach((root) => {
        setTimeout(() => {
          root.unmount();
        });
      })

      roots.current = [];

      if (marker) {
        mapRef.eachLayer((layer) => {
          if (marker._leaflet_id === layer._leaflet_id) {
            mapRef.removeLayer(layer);
          }
        })
      }

      if (data.latitude && data.longitude) {
        // eslint-disable-next-line no-undef
        const marker = L.marker([data.latitude, data.longitude], {
          // eslint-disable-next-line no-undef
          icon: L.divIcon({
            className: `map-marker icon`,
            iconSize: [24, 24],
          }),
        });

        // eslint-disable-next-line no-undef
        const popup = L.popup({ closeOnClick: true, autoClose: true })
          .setContent(getMarkerContent(data));

        marker.bindPopup(popup);
        mapRef.setView([data.latitude, data.longitude], 8)
        mapRef.addLayer(marker);
        setMarker(marker);
      }
      // add data
    }
  }, [mapRef, data]);

  return (
    <Widget
      loading={loading}
      title={t('Consensus Location')}
      className="with-border-header flex-1 no-p-body"
    >
      <Style>
        <div className="map-cont" ref={container} />
      </Style>
    </Widget>
  );
}
